(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sbs-pdp-brand"] && !Shopify.designMode) return;
  try {
    function renderPdpCountries(root) {
  root.querySelectorAll('[data-pdp-country]').forEach(element => {
    const code = element.dataset.pdpCountry;
    if (!/^[A-Z]{2}$/.test(code)) return;
    try { element.textContent = new Intl.DisplayNames([document.documentElement.lang || 'en'], {type:'region'}).of(code); } catch {}
  });
}
renderPdpCountries(document);
document.addEventListener('shopify:section:load', event => renderPdpCountries(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sbs-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sbs-description')) {
  let descriptionId = 0;
  customElements.define('sbs-description', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.content = this.querySelector('.sbs-description__content');
      this.button = this.querySelector('button');
      if (!this.content || !this.button) return;
      this.initialized = true;
      this.expanded = false;
      this.content.id = `sbs-description-${++descriptionId}`;
      this.button.setAttribute('aria-controls', this.content.id);
      this.update = () => {
        if (!this.content.getBoundingClientRect().width) return;
        const limit = parseFloat(getComputedStyle(this).getPropertyValue('--description-height')) || 320;
        const overflows = this.content.scrollHeight > limit + 1;
        this.querySelector('.sbs-description__actions').hidden = !overflows;
        this.toggleAttribute('data-collapsed', overflows && !this.expanded);
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.button.textContent = this.expanded ? this.dataset.less : this.dataset.more;
      };
      this.button.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.update();
        if (!this.expanded) {
          const rect = this.button.getBoundingClientRect();
          if (rect.top < 0 || rect.bottom > window.innerHeight) this.button.scrollIntoView({ block: 'center' });
        }
      });
      this.content.addEventListener('focusin', () => {
        if (!this.expanded) { this.expanded = true; this.update(); }
      });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.content);
      this.addEventListener('load', this.update, true);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('load', this.update, true);
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
